import { ProductRelationshipProductPair } from 'src/app/models/interfaces/ProductRelationshipProductPair';
import { Attribute, ModelChange } from '../../Attribute';
import { AttributeInstance } from './AttributeInstance';
import { AttributePair, Product } from '../../Product';
import { Observable } from 'rxjs';
import { AttributeValueOrNumber } from '../AttributeValueInstances/AttributeValueInstance';
import { AttributeWithAttributeChildren } from '../AttributeSettingsController';

export class ModelChangeInstance extends AttributeInstance<ModelChange> {
  private _attributeProducts?: ProductRelationshipProductPair[];

  constructor(attributeValue: ModelChange) {
    super(attributeValue);
    this._isApplied = false;
  }

  /* public override setAttributeChildren(attribute: Attribute, products: ProductRelationshipProductPair[]) {
    if (this._attribute === attribute) {
      this._attributeProducts = products;
    }
    super.setAttributeChildren(attribute, products);
  }

  public override getAttributeChildren(attribute: Attribute, attributeChildren: ProductRelationshipProductPair[]) {
    if (this._attributeProducts && attribute === this._attribute) {
      for (const attributeProduct of this._attributeProducts) {
        attributeChildren.push(attributeProduct);
      }
    }
    super.getAttributeChildren(attribute, attributeChildren);
  }

  public override getAllAttributeChildren(attributeWithAttributeChildren: AttributeWithAttributeChildren[]): void {
    if (this._attributeProducts) {
      attributeWithAttributeChildren.push({ attribute: this._attribute, children: this._attributeProducts });
    }
    super.getAllAttributeChildren(attributeWithAttributeChildren);
  } */
}
